export class ApiApplicationSearchConstants {
    // static readonly TOWN_PLANNING_ENDPOINT = "TownPlanning";
    // static readonly CEMETERY_ENDPOINT = "Cemetery";
    // static readonly WAYLEAVE_ENDPOINT = "Wayleave";
    // static readonly BUILDING_PLANS_ENDPOINT = "BuildingPlans";
    // static readonly PROPERTY_AND_LEASE_ENDPOINT = "PropertyAndLease";
    // static readonly PROPERTY_VALUATION_ENDPOINT = "PropertyValuation";
    static FUNCTION_GET_USERS_FOR_MODULE = "GetUsers";
    static FUNCTION_GET_TOWNPLANNERS = "GetTownPlanners";
    static FUNCTION_GET_APPLICATIONS_BY_USER = "GetApplicationsByUser";
    static FUNCTION_GET_TP_APPLICATIONS_BY_USER = "GetTpApplicationsByUser";
    static FUNCTION_GET_EH_APPLICATIONS_BY_USER = "GetEhApplicationsByUser";
    static FUNCTION_GET_BP_APPLICATIONS_BY_USER = "GetBpApplicationsByUser";
    static FUNCTION_GET_PL_APPLICATIONS_BY_USER = "GetPlApplicationsByUser";
    static FUNCTION_GET_CM_APPLICATIONS_BY_USER = "GetCmApplicationsByUser";
    static FUNCTION_GET_W_APPLICATIONS_BY_USER = "GetWApplicationsByUser";
    static FUNCTION_GET_DM_APPLICATIONS_BY_USER = "GetDMApplicationsByUser";
    static FUNCTION_GET_RC_APPLICATIONS_BY_USER = "GetRcApplicationsByUser";
    static FUNCTION_GET_EC_APPLICATIONS_BY_USER = "GetECpplicationsByUser";
    static FUNCTION_GET_TM_APPLICATION_BY_USER = "GetTmApplicationByUser";
    static FUNCTION_GET_CM_APPLICATIONS_WITH_FAMILIES = "GetCmApplicationsWithFamilies";
    static FUNCTION_GET_CM_APPLICATIONS_WITH_GRAVE = "GetCmApplicationsWithGrave";
    static FUNCTION_GET_PL_APPLICATIONS_WITH_GROUPS = "GetPlApplicationsWithGroups";
}
